module.exports = __webpack_public_path__ + "static/chefs-bg-rectangle-e4acf4d273f1fbf6a6bd1304e16f1e8a.png";